import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/list-view/extra-reducers';
import reducers from 'src/redux/list-view/reducers';
import { listViewInitialState } from './types';

const listViewSlice = createSlice({
  name: 'listView',
  initialState: listViewInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  clearListingConfigData,
  clearViewList,
  applyGroupBy,
  clearGroupByDetails,
  clearGroupBy,
  resetFetchingGroupByDetails,
  updateColumns,
  applySearch,
  setIsViewDetailsFetched,
  setToggleGroup,
  applySort,
  clearFilters,
  updateFilter,
  updateFilterComponent,
  promptListViewHasChanges,
  setViewAsDefault,
  reNameViewItem,
  deleteViewItem,
  addDuplicateView,
  addNewViewItem,
  setIsViewListLoading,
  updateViewListWhenPinnedToNav,
  updateSelectedDateInCalendarView,
  updateTechnicianInCalenderView,
  updateWorkingHoursInCalendarView,
  updateCalendarModeView,
  updateViewDetails,
  hydrateBootViewCache,
  markViewsPrefetchFailed,
  resetViewsPrefetchState,
  setSelectedGroupByDetailsData,
  updateSelectedGroupByDetailsData,
  setFilterFieldValueData,
  restListViewChangeWatcher,
  updateFilterValueLookup,
  setColumnsForRoles,
  setIsViewDetailsFetching,
  setSelectedMarkets,
  seedSelectedMarkets,
} = listViewSlice.actions;

export default listViewSlice.reducer;
